import React from "react";
import {  MDBContainer, MDBRow, MDBCol, MDBIcon, MDBCardBody, MDBCardText,  MDBCardTitle } from "mdbreact";

const AccessDenied = () => {
  return (
    <MDBContainer className="mt-5 text-center" fluid>
      <MDBRow>
        <MDBCol>
         
            <MDBCardBody>
            
          <MDBCardTitle className="h2">
                <b>
               Access Denied</b>
              </MDBCardTitle>
              <p className="red-text my-4 font-weight-bold">
                  <MDBIcon icon="lock" size="9x" color="blue-text"></MDBIcon>
           
              </p>
              <MDBCardText>
                You are not allowed to view this resource. Please contact the administrator for more details.
              </MDBCardText>
              <hr className="my-4" />
              <div className="pt-2">
             
              </div>  

{/* <img src={process.env.PUBLIC_URL + "/loading.gif"} style={{width:"300px",textAlign:"center"}} alt="loading" />
            <h3 className="h3-responsive">Please wait while we are processing your request.</h3> */}
            </MDBCardBody>
        
        </MDBCol>
      </MDBRow>
    </MDBContainer>
  )
}

export default AccessDenied;